import { Injectable } from '@angular/core';

interface IceWindowExt extends Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    DY: {
        recommendationContext: unknown;
    };
}
declare let window: IceWindowExt;

@Injectable({
    providedIn: 'root',
})
export class IceService {
    public setLanguage(language: string): void {
        let iceLanguage = 'de_DE';
        if (language.includes('en')) {
            iceLanguage = 'en.*';
        }
        if (language.includes('fr')) {
            iceLanguage = 'fr_FR';
        }
        if (language.includes('nl')) {
            iceLanguage = 'nl_NL';
        }
        if (!window.DY) {
            return;
        }

        window.DY.recommendationContext = {
            type: 'OTHER',
            lng: iceLanguage,
        };
    }
}
